/*
  Mega menu v4 — hover to open, click to navigate, drag-proof.

  ROOT CAUSE FIX for the "frozen page" bug:
  A press-and-drag on nav text or a card image starts a native browser
  drag/selection. Native drags suppress all mouse/pointer events tab-wide.
  The v1-v3 close timer then mutated the DOM (collapsing the <details>)
  mid-drag, wedging Chrome's drag session and leaving the tab with mouse
  events permanently suppressed ("frozen in whatever state at unclick").

  v4 defenses:
  1. dragstart is cancelled for the ENTIRE inline nav (capture phase) —
     covers summaries, links, card images, and selected text alike.
  2. All images in the nav get draggable=false (Firefox coverage).
  3. The close timer is drag-aware: if a native drag is active anywhere,
     closing is deferred until the drag ends. No DOM mutation mid-drag.
  4. Recovery nets kept from v2: outside-click, Escape, window blur.
*/

(function () {
  const HOVER_MQ = window.matchMedia('(hover: hover) and (pointer: fine)');
  const DESKTOP_MQ = window.matchMedia('(min-width: 990px)');
  const CLOSE_DELAY_MS = 150;

  const hoverMode = () => HOVER_MQ.matches && DESKTOP_MQ.matches;

  // --- Drag session tracking (document-wide) ---
  let dragActive = false;
  let pendingClosers = [];

  function onDragSettled() {
    dragActive = false;
    // Run any close that was deferred during the drag
    pendingClosers.forEach((fn) => fn());
    pendingClosers = [];
  }

  document.addEventListener('dragstart', () => { dragActive = true; }, true);
  document.addEventListener('dragend', onDragSettled, true);
  document.addEventListener('drop', onDragSettled, true);

  function closeMenu(details) {
    if (dragActive) {
      // NEVER mutate the DOM mid-drag — defer until the drag settles.
      pendingClosers.push(() => closeMenu(details));
      return;
    }
    details.removeAttribute('open');
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    document
      .querySelectorAll('.header__inline-menu header-menu > details[open]')
      .forEach((details) => {
        if (details !== except) closeMenu(details);
      });
  }

  function initMegaMenuHover() {
    const nav = document.querySelector('.header__inline-menu');
    if (!nav) return;

    // 1. No drag may ever begin from the nav — text, links, or images.
    nav.addEventListener('dragstart', (event) => event.preventDefault(), true);

    // 2. Belt-and-suspenders for Firefox: mark nav images non-draggable.
    nav.querySelectorAll('img').forEach((img) => (img.draggable = false));

    nav.querySelectorAll('header-menu > details').forEach((details) => {
      const summary = details.querySelector('summary');
      if (!summary) return;

      const url = summary.dataset.url;
      let closeTimer = null;

      details.addEventListener('pointerenter', () => {
        if (!hoverMode()) return;
        clearTimeout(closeTimer);
        closeAll(details);
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('pointerleave', () => {
        if (!hoverMode()) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => closeMenu(details), CLOSE_DELAY_MS);
      });

      // Click navigates instead of toggling — real mouse clicks only.
      if (url && url !== '#') {
        summary.addEventListener('click', (event) => {
          if (!hoverMode()) return;        // touch devices: stock toggle
          if (event.detail === 0) return;  // keyboard: stock toggle
          if (event.metaKey || event.ctrlKey || event.shiftKey) return; // modifier clicks: stock toggle
          event.preventDefault();
          window.location.href = url;
        });
      }
    });

    // --- Recovery nets ---
    document.addEventListener('pointerdown', (event) => {
      const insideOpenMenu = event.target.closest(
        '.header__inline-menu header-menu > details[open]'
      );
      if (!insideOpenMenu) closeAll();
    });

    document.addEventListener('keyup', (event) => {
      if (event.key === 'Escape') closeAll();
    });

    window.addEventListener('blur', () => {
      // A window blur can coincide with an OS-level drag; settle first.
      onDragSettled();
      closeAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenuHover);
  } else {
    initMegaMenuHover();
  }
})();
